import { tTypeAttachment } from '../../MessageBubble.type.ts';

export default function StickerContent(props: tTypeAttachment) {
  return (
    <div className="flex justify-center">
      <img
        src={props.attachment.url ?? ''}
        alt={props.attachment.filename ?? ''}
        className="max-w-40 object-cover"
        loading="lazy"
      />
    </div>
  );
}
